export function constrainFloatingPosition({
  x,
  y,
  viewportWidth,
  viewportHeight,
  elementWidth,
  elementHeight,
  margin = 16,
}) {
  const maxX = Math.max(margin, viewportWidth - elementWidth - margin);
  const maxY = Math.max(margin, viewportHeight - elementHeight - margin);

  return {
    x: Math.min(Math.max(x, margin), maxX),
    y: Math.min(Math.max(y, margin), maxY),
  };
}

export function defaultFloatingPosition({
  viewportWidth,
  viewportHeight,
  elementWidth,
  elementHeight,
  margin = 16,
}) {
  return constrainFloatingPosition({
    x: viewportWidth - elementWidth - margin,
    y: viewportHeight - elementHeight - margin,
    viewportWidth,
    viewportHeight,
    elementWidth,
    elementHeight,
    margin,
  });
}
